// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__OEkIk","item":"Breadcrumbs_item__ZtqRp"};